import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { a as u, s as v, t as C, u as g, v as D, j as z, w as P, x as j, y as k, z as F, A as I, B as w, C as y, D as B, d as H } from "../../vendor-Dd6qj6gJ.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as M } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as n } from "../BaseIcon/index.js";
import { FieldDescription as A } from "../FieldDescription/index.js";
import { FieldError as E } from "../FieldError/index.js";
import { FieldLabel as G } from "../FieldLabel/index.js";
import { c as a, C as L } from "../../CalendarHeader-B8Q81Mj_.js";
function O(r, c) {
  return r != null && c !== null && c !== void 0 && c.compare(r) < 0 ? r : c;
}
function R(r, c, o) {
  return r === null ? null : c != null && r.compare(c) < 0 ? c : o != null && r.compare(o) > 0 ? o : r;
}
function Z({
  label: r,
  description: c,
  errorMessage: o,
  fullWidth: i = !1,
  horizontal: $ = !1,
  value: p,
  defaultValue: b,
  onChange: m,
  minValue: t,
  maxValue: h,
  ...l
}) {
  const [x, N] = u(
    p,
    b ?? null,
    m
  ), f = O(t, h);
  return /* @__PURE__ */ s(
    v,
    {
      ...M(l),
      value: x,
      onChange: (d) => N(R(d, t, f)),
      minValue: t,
      maxValue: f,
      className: H(a.datePicker, {
        [a.fullWidth]: i,
        [a.horizontal]: $
      }),
      "data-component": "DatePicker",
      children: [
        /* @__PURE__ */ e(G, { className: a.label, children: r }),
        /* @__PURE__ */ s(C, { className: a.fieldControl, children: [
          /* @__PURE__ */ e(n, { icon: "date", size: "sm", className: a.startIcon }),
          /* @__PURE__ */ e(g, { className: a.dateInput, children: (d) => /* @__PURE__ */ e(D, { segment: d, className: a.segment }) }),
          /* @__PURE__ */ e(z, { className: a.trigger, "aria-label": "Open calendar", children: /* @__PURE__ */ e(n, { icon: "chevron-down", size: "sm" }) })
        ] }),
        /* @__PURE__ */ e(A, { children: c }),
        /* @__PURE__ */ e(E, { children: o }),
        /* @__PURE__ */ e(P, { className: a.popover, placement: "bottom start", children: /* @__PURE__ */ e(j, { className: a.dialog, "aria-label": r ?? l["aria-label"], children: /* @__PURE__ */ s(k, { className: a.calendar, children: [
          /* @__PURE__ */ e(L, {}),
          /* @__PURE__ */ s(F, { className: a.calendarGrid, children: [
            /* @__PURE__ */ e(I, { children: (d) => /* @__PURE__ */ e(w, { className: a.calendarHeaderCell, children: d }) }),
            /* @__PURE__ */ e(y, { children: (d) => /* @__PURE__ */ e(B, { date: d, className: a.calendarCell }) })
          ] })
        ] }) }) })
      ]
    }
  );
}
export {
  Z as DatePicker
};
